import { Grid } from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useTrail, animated } from "react-spring";
import { Parallax, ParallaxProvider } from "react-scroll-parallax";

const useStyles = makeStyles((theme) => ({
  title: {
    color: "#212a2f",
    marginBottom: "20px",
    marginTop: "20px",
    fontSize: "32px",
    [theme.breakpoints.between("xs", "sm")]: {
      fontSize: "25px",
    },
  },
}));

export default function Title(props) {
  const classes = useStyles();
  const {text} = props
  const items = text || ["Worship", "Praise", "Pray"];
  const [toggle, set] = React.useState(true);
  const config = { mass: 2, tension: 2000, friction: 500 };

  const trail = useTrail(text.length, {
    config,
    opacity: toggle ? 1 : 0,
    x: toggle ? 0 : 20,
    height: toggle ? 40 : 0,
    from: { opacity: 0, x: 20, height: 0 },
  });
  return (
    <Grid container direciton="row" justify="center">
      <h1>
        {trail.map(({ x, height, ...rest }, index) => (
          <animated.span
            key={items[index]}
            className="trails-text"
            style={{
              ...rest,
              transform: x.interpolate((x) => `translate3d(0,${x}px,0)`),
            }}
          >
            <animated.span style={{ height }}>{items[index]}</animated.span>
          </animated.span>
        ))}
      </h1>
    </Grid>
  );
}
